import React from 'react'
import { Form, Col, Row } from 'react-bootstrap'
import Selector from '../../dimensions/selector'
import { Tag } from 'react-bootstrap-icons'
import useViewport from '../../../hooks/use-viewport'

const EditDimensions = ({
    value = [],
    onChange = () => {},
}) => {
    const { breakpoint, breakpoints } = useViewport()
    return (
        <Form.Group as={Row}>
            <Form.Label column  sm={12} md={1} lg={2} xl={6} style={{ paddingRight: '0px' }}>
                <Tag size={30} />  {breakpoint >= breakpoints.XL || breakpoint <= breakpoints.SM ? 'Dimension' : ''}
            </Form.Label>
            <Col sm={12} md={11} lg={10} xl={6}>
                <Selector value={value} onChange={onChange} />
            </Col>
        </Form.Group>
    )
}

export default EditDimensions